<template>
  <Toast />
  <section>
    <base-card>
      <h2>Creacion de Usuarios App Movil</h2>
      <UsuariosnewForm @save-data="saveData"></UsuariosnewForm
    ></base-card>
  </section>
</template>

<script>
import UsuariosnewForm from '../../components/usuarios/UsuariosnewForm.vue';
export default {
  components: {
    UsuariosnewForm,
  },
  data() {
    return { error: null };
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  methods: {
    handleError() {
      this.error = null;
    },
    async saveData1(data, dir) {
      console.log(data + dir);
    },
    removeItemFromArr(arr, item) {
      console.log(arr);
      var i = arr.indexOf(item);

      if (i !== -1) {
        arr.splice(i, 1);
      }
    },
    async saveData(data, dir) {
      console.log(data + dir);
      try {
        const response = await this.$store.dispatch('Usuarios', data, 'POST');
        console.log(response)
        if (response[0].codigo == '00011') {
          this.$toast.add({
            severity: 'success',
            summary: 'Usuario agreado ',
            detail: response[0].mensaje,
            //group: 'br',
            life: 2000,
          });
          setTimeout(() => {
          this.$router.replace('/usuarios');
        }, 2000);
        } else {
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: response[0].mensaje,
            //group: 'br',
            life: 2000,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
